import React from 'react'
import { TbSocial } from "react-icons/tb";
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import {TextInput,CustomButton} from "../components"
import { BsMoon, BsSunFill } from 'react-icons/bs';
import { IoMdNotificationsOutline } from "react-icons/io";
import { SetTheme } from "../redux/theme";
import { Logout } from "../redux/userSlice";
import { fetchPosts } from '../utils';
const TopBar = () => {
    const {theme} = useSelector(
        (state) => state.theme
    );

    const {user} = useSelector(
        (state) => state.user
    );

    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm();

      const handleTheme = () => {
        const themeValue = theme === "light" ? "dark" : "light";
    
        dispatch(SetTheme(themeValue));
      };
      const handleSearch = async(data) => {

        await fetchPosts(user.token , dispatch , "" , data);
      }
    const dispatch = useDispatch();
  return (
    <div className='topbar w-full flex items-center justify-between py-3 md:py-6 px-4 bg-primary rounded-lg'>
        <Link to='/' className='flex gap-2 items-center'>
            <div className='p-1 md:p-2 bg-[#5356ff] rounded text-white'>
            <TbSocial />
            </div>
            <span className='text-xl md:text-2xl text-[#5356ff] font-semibold'>
            Connectify
            </span>
      </Link>

      <form
        className='hidden md:flex items-center justify-center'
        onSubmit={handleSubmit(handleSearch)}
      >
        <TextInput
          placeholder='Search...'
          styles='w-[18rem] lg:w-[38rem]  rounded-l-full py-3 '
          register={register("search")}
        />
        <CustomButton
          title='Search'
          type='submit'
          containerStyles='bg-[#5356ff] text-white px-6 py-3 mt-2 rounded-r-full'
        />
      </form>

      { /* ICONS */}
      <div className='flex items-center gap-4 text-ascent-1 text-md md:text-xl'>
        <button onClick={()=>handleTheme()}>
            {theme ==="light" ? <BsMoon/> : <BsSunFill/>}
        </button>

        <div className='hidden lg:flex'>
          <IoMdNotificationsOutline />
        </div>

        <div>
          <CustomButton
            onClick={() => dispatch(Logout())}
            title='Log Out'
            containerStyles='text-sm text-ascent-1 px-4 md:px-6 py-1 md:py-2 border border-[#666] rounded-full'
          />
        </div>
      </div>
    </div>
  )
}

export default TopBar